"use client";

import { createContext } from "react";

/**
 * Provides the current form section/step key to descendant fields.
 *
 * Used by wizard slides (BaseSlide) and form flow panels to tag
 * registered fields with their section, so the AI agent knows
 * which fields belong to which step.
 *
 * Fields read this context via useFormValidation, which merges
 * the section key into field metadata automatically.
 */
export const FormSectionContext = createContext<string | null>(null);
